<h1 class="mf-popup-title overflow-hidden text-nowrap">
    <span *ngIf="!isEdit">Dodaj pravno osebo</span>
    <span *ngIf="isEdit">Urejanje pravne osebe</span>
</h1>
<form [formGroup]="inputForm" novalidate>
    <div class="m-portlet mf-portlet-gray__gray-background">
        <div class="m-portlet__body">
            <div class="m-content">
                <div class="m-list-search">
                    <div class="m-list-search__results">
                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon">
                                <i ngbTooltip="Naziv" class="la la-i-cursor m--font-inverse-light" i18n-ngbTooltip></i>
                            </span>
                            <span class="m-list-search__result-item-text">
                                <input
                                    type="text"
                                    placeholder="Naziv"
                                    formControlName="name"
                                    class="form-control form-control-sm m-input"
                                    i18n-placeholder
                                />
                            </span>
                        </div>
                        <div *ngIf="inputForm.controls['name'].errors && formSubmitted" class="m--font-danger ml-4">
                            <div [hidden]="!inputForm.controls['name'].errors.required" class="ml-3" i18n="@@new.payer.error.title">
                                Naziv je obvezno polje.
                            </div>
                        </div>
                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon">
                                <i class="la la-map-marker m--font-inverse-light"></i>
                            </span>
                            <div class="row">
                                <div class="col-xl-6 col-md-6">
                                    <input
                                        type="text"
                                        placeholder="Ulica"
                                        formControlName="addressName"
                                        class="form-control form-control-sm m-input"
                                        i18n-placeholder
                                    />
                                    <div *ngIf="inputForm.controls['addressName'].errors && formSubmitted" class="m--font-danger">
                                        ERROR
                                        <div
                                            [hidden]="!inputForm.controls['addressName'].errors?.required"
                                            class=""
                                            i18n="@@new.payer.error.addressName"
                                        >
                                            Ulica je obvezno polje1.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-md-6">
                                    <input
                                        type="text"
                                        placeholder="Hišna številka"
                                        formControlName="addressNumber"
                                        class="form-control form-control-sm m-input"
                                        i18n-placeholder
                                    />
                                    <div *ngIf="inputForm.controls['addressNumber'].errors && formSubmitted" class="m--font-danger">
                                        <div
                                            [hidden]="!inputForm.controls['addressNumber'].errors.required"
                                            class=""
                                            i18n="@@new.payer.error.addressNumber"
                                        >
                                            Hišna številka je obvezno polje.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon"></span>
                            <span class="m-list-search__result-item-text">
                                <div class="row">
                                    <div class="col-xl-6 col-md-6">
                                        <ng-select
                                            [items]="zipCodes"
                                            [addTag]="true"
                                            [clearable]="false"
                                            [virtualScroll]="true"
                                            (change)="fillCity($event)"
                                            bindLabel="zipCode"
                                            bindValue="zipCode"
                                            addTagText="Dodaj poštno št."
                                            placeholder="Poštna številka"
                                            formControlName="postNumber"
                                            i18n-placeholder="@@post_number"
                                        ></ng-select>

                                        <div *ngIf="inputForm.controls['postNumber'].errors && formSubmitted" class="m--font-danger">
                                            <div
                                                [hidden]="!inputForm.controls['postNumber'].errors.required"
                                                class=""
                                                i18n="@@new.payer.error.postNumber"
                                            >
                                                Poštna številka je obvezno polje.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-md-6">
                                        <ng-select
                                            [items]="zipCodes"
                                            [addTag]="true"
                                            [clearable]="false"
                                            [virtualScroll]="true"
                                            (change)="fillPost($event)"
                                            bindLabel="city"
                                            bindValue="city"
                                            addTagText="Dodaj pošto"
                                            placeholder="Pošta"
                                            formControlName="postName"
                                            i18n-placeholder="@@post_city"
                                        ></ng-select>
                                        <div *ngIf="inputForm.controls['postName'].errors && formSubmitted" class="m--font-danger">
                                            <div
                                                [hidden]="!inputForm.controls['postName'].errors.required"
                                                class=""
                                                i18n="@@new.payer.error.postName"
                                            >
                                                Pošta je obvezno polje.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>

                        <section>
                            <div class="m-list-search__result-item">
                                <span class="m-list-search__result-item-icon">
                                    <span ngbTooltip="Poštni predal" class="la la-inbox m--font-inverse-light" i18n-ngbTooltip></span>
                                </span>
                                <span class="m-list-search__result-item-text">
                                    <input
                                        formControlName="postBox"
                                        type="text"
                                        placeholder="Poštni predal"
                                        class="form-control form-control-sm m-input"
                                        i18n-placeholder
                                    />
                                </span>
                            </div>
                            <div *ngIf="inputForm.controls['postBox'].errors && formSubmitted" class="m--font-danger ml-4">
                                <div [hidden]="!inputForm.controls['postBox']?.errors?.pattern" class="ml-3" i18n="@@new.payer.error.postBox">
                                    Dovoljen vnos samo števil.
                                </div>
                            </div>
                        </section>
                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon">
                                <span ngbTooltip="Davčna številka" class="la la-euro m--font-inverse-light" i18n-ngbTooltip></span>
                            </span>
                            <span class="m-list-search__result-item-text">
                                <input
                                    formControlName="taxId"
                                    type="text"
                                    placeholder="Davčna številka"
                                    class="form-control form-control-sm m-input"
                                    i18n-placeholder
                                />
                                <div *ngIf="inputForm.controls['taxId'].errors && formSubmitted" class="m--font-danger">
                                    <div [hidden]="!inputForm.controls['taxId']?.errors?.minlength">
                                        Davčna številka mora biti dolga vsaj 8 znakov.
                                    </div>
                                </div>
                            </span>
                        </div>
                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon">
                                <span
                                    ngbTooltip="Tel. št za prejem kode za dostop do računa"
                                    class="la la-phone m--font-inverse-light"
                                    i18n-ngbTooltip
                                ></span>
                            </span>
                            <span class="m-list-search__result-item-text">
                                <input
                                    formControlName="phone"
                                    type="text"
                                    placeholder="Tel. št za prejem kode za dostop do računa"
                                    class="form-control form-control-sm m-input"
                                    i18n-placeholder
                                />
                                <div *ngIf="inputForm.controls['phone'].errors && formSubmitted" class="m--font-danger">
                                    <div [hidden]="!inputForm.controls['phone']?.errors?.minlength">
                                        Telefonska številka mora biti dolga vsaj 9 znakov.
                                    </div>
                                </div>
                            </span>
                        </div>
                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon">
                                <span
                                    ngbTooltip="E-poštni naslov za prejemanje računov"
                                    class="la la-envelope m--font-inverse-light"
                                    i18n-ngbTooltip
                                ></span>
                            </span>
                            <span class="m-list-search__result-item-text">
                                <input
                                    formControlName="email"
                                    type="text"
                                    placeholder="E-poštni naslov za prejemanje računov"
                                    class="form-control form-control-sm m-input"
                                    i18n-placeholder
                                />
                                <div *ngIf="inputForm.controls['email'].errors && formSubmitted" class="m--font-danger">
                                    <div [hidden]="!inputForm.controls['email']?.errors?.email">Napačna oblika e-poštnega naslova.</div>
                                </div>
                            </span>
                        </div>
                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon">
                                <span
                                    ngbTooltip="Poljuben rok plačila za izbranega plačnika. Privzet rok plačila je enak roku plačila izvajalca (Nastavitve - Računovodstvo)"
                                    class="la la-calendar m--font-inverse-light"
                                ></span>
                            </span>
                            <span class="m-list-search__result-item-text">
                                <div class="row">
                                    <div class="col-6">
                                        <input
                                            formControlName="paymentDeadlineDays"
                                            type="number"
                                            min="0"
                                            placeholder="Rok plačila dni (Opcijsko)"
                                            class="form-control form-control-sm m-input"
                                        />
                                        <div *ngIf="inputForm.controls['paymentDeadlineDays'].errors && formSubmitted" class="m--font-danger">
                                            <div [hidden]="!inputForm.controls['paymentDeadlineDays']?.errors?.min">
                                                Valuta mora biti pozitivna vrednost
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>

                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon">
                                <span ngbTooltip="Drug naslovnik" class="la la-map-signs m--font-inverse-light" i18n-ngbTooltip></span>
                            </span>
                            <span class="m-list-search__result-item-text">
                                <label class="m-checkbox m-checkbox--brand pt-2">
                                    <input type="checkbox" formControlName="isDifferentRecipient" />
                                    Drug naslovnik
                                    <span class="mt-2"></span>
                                </label>
                            </span>
                        </div>
                    </div>
                </div>

                <section *ngIf="inputForm.get('isDifferentRecipient').value">
                    <acc-wid-cmn-rcp-form
                        [formSubmitted]="formSubmitted"
                        [recipient]="invoicePartner?.recipients ? invoicePartner.recipients[0] : undefined"
                        (onChange)="onRecipientData($event)"
                    ></acc-wid-cmn-rcp-form>
                </section>
            </div>
        </div>
    </div>
    <div class="modal-footer mf-custom-footer">
        <button
            (click)="onCloseClick()"
            type="button"
            style="width: 150px"
            class="ml-auto btn m-btn--pill btn-warning m-btn m-btn--custom"
            i18n="@@cancel"
        >
            Prekliči
        </button>
        <button (click)="saveCustomerPayer()" type="submit" style="width: 150px" class="mr-auto btn m-btn--pill btn-accent m-btn" i18n="@@confirm">
            Shrani
        </button>
    </div>
</form>
